const cyan = {
  100: "#E7FDFA",
  200: "#C7FAF2",
  300: "#A5F3E5",
  400: "#7DE8D6",
  500: "#1DD7BF",
  600: "#08C4B1",
  700: "#089B91",
  800: "#09726E",
  900: "#074B4B",
  contrastDefaultColor: "#ffffff"
}

export default cyan
